export const en = {
    add: 'Add',
    'audio-disable-reason': 'Audio from video used',
    cancel: 'Cancel',
    converting: 'Processing',
    crop: 'Crop',
    edit: 'Edit',
    'idea-source': 'Choose another from page',
    'library-source': 'Select from library',
    'link-source': 'Use URL address',
    'recent-source': 'Select from previous uploads',
    'smart-center': 'Set smart-center',
    'upload-error': 'An error occurred while uploading the file. Please try again later.',
    'upload-source': 'Upload from computer'
};
